const View = ({isPlaying, audioSource, onEndedAudio}) => {
  return (
    <>
      {isPlaying && (
        <audio
          id="audio-player"
          src={audioSource}
          onEnded={onEndedAudio}
          autoPlay
        />
      )}
    </>
  );
};

export default View;
